export default __webpack_public_path__ + "images/AIS-USA-logo.v-63748884249ae4d2d002b954b87be8ca.png";